export const API_URL = process.env.VUE_APP_PROTOCOL;
export default API_URL;
